import { clientePedido } from '../../apiClient/index'
import { showError} from '../../components/Mensaje/index'
import i18n from "../../plugins/i18n";
import { comprimir } from '../../components/FileUpload/funcionComprimir';

const maxSizeImage = 300000; // 300 kb en bytes definidos como restriccion por el cliente
var reduccionFactorCalidad = 0;
const restricciones = {
  minWidth: 200,
  minHeight: 200
}
const moduloForo = {
  namespaced: true,
  state: {},
  actions: {
    getEntradasForo(context, payload)
    {
      return new Promise((resolve) => {
        clientePedido.get('/api/Foro/FindEntradaForo', { params: payload })
        .then(response => resolve(response.data))
      })
    },

    getEntradaForo(context, id) 
    {
      return new Promise((resolve) => {
        clientePedido.get(`/api/Foro/GetEntradaForo?id=${id}`)
        .then(response => resolve(response.data))
      })
    },

    saveEntradaForo(context, payload) 
    {
      return new Promise((resolve) => {
        clientePedido.post('/api/Foro/SaveEntradaForo', payload)
        .then(response => resolve(response.data))
      })  
    },

    cambiarArchivado(context, payload) 
    {
      return new Promise((resolve) => {
        clientePedido.post(`/api/Foro/CambiarArchivado?id=${payload.id}`)
        .then(response => {
          var result = response.data
          resolve(result.CodigoResultado)
        })
      })  
    },

    updaloadImagenForo(context, payload) {
      return new Promise((resolve, reject) => {
        if(payload.file.size > maxSizeImage)
        {
          comprimir(reduccionFactorCalidad,payload.file, restricciones, function callback(blob) {
            let archivo = new File([blob], payload.file.name, {
              type: payload.file.type
            });
            // console.log("Nuevo tamanio: " + archivo.size / 1000000 + "MB")
            if(archivo.size > maxSizeImage)
            {
                reduccionFactorCalidad = reduccionFactorCalidad + 0.1;
                comprimir(reduccionFactorCalidad, archivo,restricciones, callback, (error) => {
                  if(!error)
                    showError(i18n.t('FORO_imagen_grande'));
                  reduccionFactorCalidad = 0
                  reject(error);
                });
            }
            else
            {
              let formData = new FormData()
              formData.append('imagen', archivo);
              clientePedido.post(`/api/Foro/UploadImagenEntradaForo?id=${payload.id}`, formData)
              .then(
                response => {
                  resolve(response.data) })
              .catch(error => { reject(error) })
              .finally(() => reduccionFactorCalidad = 0)
            }
          }, function descartarImagen(error) {
            if(!error)
              showError(i18n.t('FORO_imagen_grande'));
            reduccionFactorCalidad = 0;
            reject(error);
          });
        }
        else
        {
          let formData = new FormData()
          formData.append('imagen', payload.file);
          clientePedido.post(`/api/Foro/UploadImagenEntradaForo?id=${payload.id}`, formData)
          .then(
            response => {
              resolve(response.data) })
          .catch(error => {
            reject(error) })
          .finally(() => reduccionFactorCalidad = 0)
        }
          
      });
    },

    saveComentario(context, payload) {
      return new Promise((resolve) => {
        clientePedido.post('/api/Foro/SaveComentario', payload)
        .then(response => resolve(response.data))
      })
    },

    uploadImagenComentario(context, payload) {
      return new Promise((resolve, reject) => {
        if(payload.file.size > maxSizeImage)
        {
          comprimir(reduccionFactorCalidad,payload.file, restricciones, function callback(blob) {
            let archivo = new File([blob], payload.file.name, {
              type: payload.file.type
            });
            // console.log("Nuevo tamanio: " + archivo.size / 1000000 + "MB")
            if(archivo.size > maxSizeImage)
            {
                reduccionFactorCalidad = reduccionFactorCalidad + 0.1;
                comprimir(reduccionFactorCalidad, archivo,restricciones, callback, (error) => {
                  if(!error)
                    showError(i18n.t('FORO_imagen_grande'));
                  reduccionFactorCalidad = 0
                  reject(error);
                });
            }
            else
            {
              let formData = new FormData()
              formData.append('imagen', archivo);
              clientePedido.post(`/api/Foro/UploadImagenComentario?id=${payload.id}`, formData)
              .then(
                response => {
                  resolve(response.data) })
              .catch(error => { reject(error) })
              .finally(() => reduccionFactorCalidad = 0)
            }
          }, function descartarImagen(error) {
            if(!error)
              showError(i18n.t('FORO_imagen_grande'));
            reduccionFactorCalidad = 0
            reject(error);
          });
        }
        else
        {
          let formData = new FormData()
          formData.append('imagen', payload.file);
          clientePedido.post(`/api/Foro/UploadImagenComentario?id=${payload.id}`, formData)
          .then(
            response => {
              resolve(response.data) })
          .catch(error => {
            reject(error) })
          .finally(() => reduccionFactorCalidad = 0)
        }
      });
    },
    getUltimasEntradasForo(context, payload){
      return new Promise((resolve, reject) => {
        clientePedido.get('/api/Foro/FindUltimasEntradasForo', { params: payload })
        .then(response => resolve(response.data))
        .catch(() => reject())
      })
    }
  }
}

export default moduloForo